import { useSelector } from "react-redux";
import { marketFromCountry } from "./market";

/*
 * The current user's market (India vs USA), derived from their profile country.
 * Use this anywhere a surface needs country-aware behavior (currency, copy,
 * phone, or the Jobs tab's data source via market.jobSuffix).
 */
export default function useMarket() {
  const country = useSelector((s) => s.profile.profileData && s.profile.profileData.country);
  return marketFromCountry(country);
}
